import React from 'react';
import { func, string } from 'prop-types';

const SearchBox = ({
  styleName = '', placeholder = '', onChange, value = '',
}) => (
  <div className={`gx-search-bar ${styleName}`}>
    <div className="gx-form-group">
      <input
        className="ant-input"
        type="search"
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
      <span className="gx-search-icon gx-pointer"><i className="icon icon-search" /></span>
    </div>
  </div>
);

SearchBox.propTypes = {
  styleName: string,
  placeholder: string,
  onChange: func.isRequired,
  value: string,
};

export default SearchBox;
